var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-invite-create"},[_c('b-container',[_c('CustomerInviteForm',{on:{"invite-sent":_vm.handleInviteSent,"invite-error":_vm.handleInviteError}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }